import { Dispatch, SetStateAction } from 'react';
import { CarDetailsHeader } from '../../CarDetailsHeader/car-details-header';
import { CarDetailsType } from '@/types';
import BottomSheetNoPadding from '@/components/shared/bottom-sheet/bottom-sheet-no-padding.component';
import { CarTypeDescription } from './car-type-desc';
import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import CarCTAs from '../../CarCTAs';
import { useTranslation } from 'react-i18next';
import { CarIncludesDetailedItems } from './car-includes-detailed-items';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { AvailableCarIncludes, CarIncludesMap } from '../car-includes.type';

export const CarIncludeBottomSheet = ({
    openBottomSheet,
    setOpenBottomSheet,
    showCarDetailsHeader,
    selectedCar,
    carType,
    gradientColor,
}: {
    openBottomSheet: boolean;
    setOpenBottomSheet: Dispatch<SetStateAction<boolean>>;
    showCarDetailsHeader: boolean;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
    gradientColor: string;
}) => {
    const { t, i18n } = useTranslation();
    const requiredIncludes = CarIncludesMap[carType];
    const toBeIcluded = requiredIncludes.map(i => AvailableCarIncludes[i]);
    return (
        <BottomSheetNoPadding
            open={openBottomSheet}
            setOpen={setOpenBottomSheet}
            className="!rounded-xl"
            drawerHeight="90%"
        >
            <div
                className="w-full min-h-full flex flex-col relative bg-white"
                style={{
                    background: `linear-gradient(180deg, ${gradientColor} 0%, rgba(254, 250, 245, 0) 32%), #FFF`,
                }}
            >
                <div>
                    <div className="flex justify-center">
                        <div className="bg-gray-300 rounded-[100px] h-1 w-20 my-3 "></div>
                    </div>
                    <div className="mx-4 my-3 ">
                        {showCarDetailsHeader && (
                            <CarDetailsHeader
                                title={t('CarProfile.CarBenefits')}
                                selectedCar={selectedCar}
                                carType={carType}
                            />
                        )}
                    </div>
                    {/* <CarTypeVideoEntryPoint
                        carType={carType}
                        IS_DESKTOP={false}
                    /> */}
                </div>
                <div className="px-4 mb-2">
                    <div className="pb-3">
                        <CarTypeDescription carType={carType} />
                    </div>
                    <div className="pt-2">
                        <CarIncludesDetailedItems
                            lang={i18n.language as AVAILABLE_LANGUAGES}
                            toBeIcluded={toBeIcluded}
                        />
                    </div>
                </div>
            </div>
            <CarCTAs
                carInfo={selectedCar}
                t={t}
                IS_DESKTOP={false}
                showTip={false}
            />
        </BottomSheetNoPadding>
    );
};
